export default function () {
  const widgetName = 'logoCards';
  const widgetOpts = logoCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.buttonwrap').remove();
        $(this).removeAttr('target');


        // Accessibility attrs
        $(this).attr('title', data.items[x].Description);
        $(this).find('.card-widget-image').attr('alt', data.items[x].Description);
        $(this).attr('aria-label', data.items[x].Description);
        $(this).attr('role', 'link');
        

        $(this).append('<div class="overlay"></div>');
        let tokenTitle = $(this).find('.card-widget-title').text();
        let logoPath = data.items[x].ImageWithPath;


        switch (tokenTitle) {
          case '{fairgrounds}':
            $(this).find('.overlay').addClass('overlay-fairgrounds');

            if ($(body).hasClass('fairgrounds-subpage')) {
              $('.header-logo').attr('href', $(this).attr('href'));
              $('.header-logo').css('background-image', `url('${logoPath}')`);
            }
            break;
          case '{bhss}':
            $(this).find('.overlay').addClass('overlay-bhss');

            if ($(body).hasClass('BHSS-subpage')) {
              $('.header-logo').attr('href', $(this).attr('href'));
              $('.header-logo').css('background-image', `url('${logoPath}')`);

            }

            break;
          case '{csf}':
            $(this).find('.overlay').addClass('overlay-csf');

            if ($(body).hasClass('CSF-subpage')) {
              $('.header-logo').attr('href', $(this).attr('href'));
              $('.header-logo').css('background-image', `url('${logoPath}')`);
            }

            break;
          case '{cssf}':
            $(this).find('.overlay').addClass('overlay-cssf');

            if ($(body).hasClass('CSF_Foundation-subpage')) {
              $('.header-logo').attr('href', $(this).attr('href'));
              $('.header-logo').css('background-image', `url('${logoPath}')`);
            }
            break;
          default:

        }


        if($(body).hasClass('homepage')){
          $(this).appendTo('#clonedLogos')
        }
        $(this).find('.card-widget-title').remove();        
      })
      

      if (data.items.length == 0) {
        $('.tier-2-container .left-panel').remove();
        $('.tier-2-container .inner-container').css('justify-content', 'center');
      }

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}